import React from 'react';
import { motion } from 'framer-motion';

// --- PRELOADER COMPONENT ---
const Preloader = () => {
    const word = "SOLUTIONS".split("");
    
    const containerVariants = {
        hidden: { opacity: 1 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.1, delayChildren: 0.2 }
        },
        // --- THE DEFINITIVE FIX ---
        exit: { 
            opacity: 0, 
            transition: { duration: 0.5, ease: "easeInOut" },
            // This special property tells Framer Motion to apply `display: "none"`
            // only AFTER the opacity animation is 100% complete.
            // This is the most reliable way to prevent layout shifts.
            transitionEnd: {
                display: "none"
            }
        }
    };
    
    const letterVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0 }
    };

    return (
        <motion.div
            className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-black"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
        >
            <div className="text-center">
                <motion.h1 className="text-5xl md:text-7xl font-bold text-white tracking-tighter mb-2">
                    SMART
                </motion.h1>
                <motion.h1 className="text-5xl md:text-7xl font-bold text-cyan-400 tracking-tighter" variants={containerVariants}>
                    {word.map((letter, index) => (
                        <motion.span key={index} variants={letterVariants} className="inline-block">
                            {letter}
                        </motion.span>
                    ))}
                </motion.h1>
            </div>
        </motion.div>
    );
};

export default Preloader;